import { Injectable } from '@angular/core';

import { StorageService } from './storage.service';
import { SysUser } from '../../proxy/models/common';

@Injectable({
    providedIn: 'root'
})
export class UserService {
    private readonly storageKey = 'uatUser';

    constructor(
        private storageService: StorageService
    ) {
    }

    public saveUser(user: SysUser): void {
        this.storageService.saveData(this.storageKey, JSON.stringify(user));
    }

    public getUser(): SysUser | null {
        const user = this.storageService.getData(this.storageKey);
        return (user && JSON.parse(user)) || null;
    }

    public removeUser(): void {
        this.storageService.removeData(this.storageKey);
    }
}
